import React, { Suspense } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { Box, CircularProgress } from '@mui/material';


const Login = React.lazy(() => import('./components/commonPages/login/Login'));
const Businesses = React.lazy(() => import('./components/features/business/Businesses'));
const AllJobs = React.lazy(() => import('./components/features/Jobs/AllJobs'));
const Dashboard = React.lazy(() => import('./components/features/dashboard/Dashboard'));
const Customers = React.lazy(() => import('./components/features/customers/Customers'));
const BusinessDetails = React.lazy(() => import('./components/features/business/BusinessDetails'));
const EditBusiness = React.lazy(() => import('./components/features/business/EditBusiness'));
const ForgetPassword = React.lazy(() => import('./components/commonPages/login/ForgetPassword'));
const UpdatePassword = React.lazy(() => import('./components/commonPages/login/UpdatePassword'));
const Profile = React.lazy(() => import('./components/commonPages/login/Profile'));

function App() {
  const errorHandler = (error, info) => {
    console.error("Error caught by ErrorBoundary:", error, info);
  };

  return (
    <ErrorBoundary fallback={<div>Something went wrong!</div>} onError={errorHandler}>
      <Suspense fallback={
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <CircularProgress />
        </Box>
      }>
        <Router> {/* 👈 Add this wrapper */}
          <div className="App">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/businesses" element={<Businesses />} />
              <Route path="/all-jobs" element={<AllJobs />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/business-detail" element={<BusinessDetails />} />
              <Route path="/edit-business/:userId" element={<EditBusiness />} />
              <Route path="/forget-password/:userId" element={<ForgetPassword />} />
              <Route path="/update-password/:userId" element={<UpdatePassword />} />
              <Route path="/profile" element={<Profile />} />
              {/* <Route path="/job-detail" element={<JobDetail />} />               */}
            </Routes>
          </div>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
